module.exports = __webpack_public_path__ + "img/subjectLogo.814ae0f6.png";